import { useOptimizedTasks, FamilyTask } from './useOptimizedTasks';

/**
 * Wrapper around useOptimizedTasks to maintain compatibility with legacy useTasks interface
 * This allows existing components to gradually migrate to the optimized version
 */
export function useTasks(familyId?: string) {
  const {
    tasks,
    loading,
    createTask: optimizedCreateTask,
    completeTask: optimizedCompleteTask,
    updateTask: optimizedUpdateTask,
    deleteTask: optimizedDeleteTask,
    refreshTasks
  } = useOptimizedTasks(familyId);

  // Convert optimized functions to match legacy interface
  const createTask = async (title: string, description: string, assignedTo: string, dueDate?: Date) => {
    return optimizedCreateTask(title, description, [assignedTo], dueDate);
  };

  const completeTask = async (taskId: string) => {
    return optimizedCompleteTask(taskId);
  };

  const updateTask = async (taskId: string, title: string, description: string, assignedTo: string, dueDate?: Date) => {
    return optimizedUpdateTask(taskId, title, description, [assignedTo], dueDate);
  };

  const deleteTask = async (taskId: string) => {
    return optimizedDeleteTask(taskId);
  };

  return {
    tasks,
    loading,
    createTask,
    completeTask,
    updateTask,
    deleteTask,
    refreshTasks
  };
}

// Re-export the type for compatibility
export type { FamilyTask };